<template>
  <div class="sealApplyPage" v-if="!this.showLoad">
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="sealApply.applicantIdName"
        v-if="mode != 'add'"
        readonly
        label="申请人："
        class="ggInput"
      />
      <van-field
        v-model="userinfo.realName"
        v-else
        readonly
        label="申请人："
        class="ggInput"
      />
    </van-cell-group>
    <!-- 印章-->
    <van-cell-group class="itemPerson baseNone beizhu">
      <van-field
        v-model="sealApply.sealNames"
        :required="editType"
        type="textarea"
        label="选择用章："
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="checkSealPicker"
        readonly
        rows="1"
        autosize
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="sealApply.fileAmount"
        clearable
        type="digit"
        :required="editType"
        :readonly="editType == true ? false : true"
        label="文件数量："
        :placeholder="editType ? '请输入...  ' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="sealApply.fileName"
        clearable
        :required="editType"
        :readonly="editType == true ? false : true"
        label="文件名称："
        :placeholder="editType ? '请输入...  ' : ''"
        class="ggInput"
      />
    </van-cell-group>
    <!-- 项目管理 -->
    <van-cell-group class="itemSite baseNone baseSalary beizhu">
      <van-field
        v-model="sealApply.projectName"
        :required="editType"
        label="所属项目："
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="checkItemPicker"
        readonly
        class="ggInput"
      />
    </van-cell-group>
    <!-- 用章时间 -->
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="sealApply.sealTime"
        :required="editType"
        readonly
        label="用章时间"
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="TimePicker"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary beizhu">
      <van-field
        v-model="sealApply.reason"
        rows="1"
        autosize
        :required="editType"
        clearable
        :readonly="editType == true ? false : true"
        label="用章原因："
        type="textarea"
        :placeholder="editType ? '请输入...  ' : ''"
      />
    </van-cell-group>

    <!-- 附件 -->
    <!-- 微信的附件 避免和原生交互 -->
    <wx-file-view
      v-if="is_weixn"
      :filesData="sealApply"
      :editType="editType"
      class="fileview"
    ></wx-file-view>
    <!-- 原生附件 -->
    <file-view
      v-else
      :filesData="sealApply"
      :editType="editType"
      @changeFile="changebaseAnnexes"
      class="fileview"
    ></file-view>

    <!-- 审批流程 -->
    <div
      class="approveList"
      v-if="this.mode != 'add' && sealApply.verifyStatus != 'hold'"
    >
      <audit-list :applicantData="sealApply"></audit-list>
    </div>

    <!-- 流程图 -->
    <div
      class="flowList"
      v-if="this.mode != 'add' && sealApply.verifyStatus != 'hold'"
    >
      <flow-staff :applicantData="sealApply"></flow-staff>
      <flow-list :workflowCode="sealApply.workflowCode"></flow-list>
    </div>
    <!-- 审批 -->
    <van-popup
      v-model="verifyPageType"
      closeable
      round
      close-icon="close"
      position="bottom"
      class="verifyPage"
    >
      <verify-main :applicantData="sealApply"   @changeVerifyType="setVerifyType"></verify-main>
    </van-popup>

    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        @click="checkInput"
        :loading="btnLoading"
        :loading-text="loadingText"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="sealApply.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              @click="delApply"
              :loading="btnLoading"
              :loading-text="loadingText"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="sealApply.verifyStatus == 'deny' && mode != 'verify'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        sealApply.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="BackApply"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          sealApply.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          sealApply.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">{{
        verifyPageText
      }}</van-button>
    </div>
    <!-- 弹出层 -->
    <!--  印章列表 -->
    <van-popup
      v-model="showSealPicker"
      position="bottom"
      class="roleBox"
      @opened="changeSealdata"
      @close="closeSealPicker"
    >
      <div class="roleHeader clearfix">
        <a href="javascript:void(0);" class="fl" @click="closeSealPicker"
          >取消</a
        >
        请选择用章
        <a href="javascript:void(0);" class="fr" @click="saveSeal">确认</a>
      </div>

      <van-checkbox-group v-model="result" class="roleMain">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in sealList"
            clickable
            :key="item.index"
            :title="`${item.sealName}`"
            @click="toggle(index)"
          >
            <van-checkbox
              :name="item.sealName"
              ref="checkboxes"
              slot="right-icon"
            />
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </van-popup>
    <!-- 项目列表 -->
    <van-popup v-model="showItemPicker" position="bottom" class="itemBox">
      <project-view @setItems="setProject"></project-view>
    </van-popup>
    <!-- 时间控件 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        @cancel="showTimePicker = false"
        @confirm="onTimeConfirm"
        :min-date="minDate"
      />
    </van-popup>

    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { dateTimeFormat, isEdit } from "@/utils/common";
import { mapState, mapMutations } from "vuex";
import { getDeviceType, closePage ,is_wei} from "@/common/getDeviceType/getDeviceType";
const projectView = () => import("@/components/businessTripMould/projectView");
const refreshPage = () => import("@/components/common/refreshPage");
const fileView = () => import("@/components/common/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
const flowStaff = () => import("@/components/common/flowStaff");

export default {
  name: "sealApply",
  components: {
    projectView,
    refreshPage,
    fileView,
    wxFileView,
    auditList,
    flowList,
    verifyMain,
    flowStaff,
  },
  data() {
    return {
      commonType: "",
      commonId: "",
      sealApply: {
        sealNames: "", //印章的名称
        projectId: "", //项目id
        projectName: "", //项目名称
        fileAmount: "", //文件份数
        fileName: "", //文件名称
        reason: "", //文件原因
        sealIds: [], //保存的公章id
        sealTime: "", //盖章时间
        verifyStatus: "hold",
        baseAnnexes: [],
      },
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      mode: "add",
      editType: false,
      showSealPicker: false, //
      sealList: [], //印章列表
      result: [], //选择的印章列表
      sealdata: [], //选到的印章列表
      cloneSealdata: [],
      showItemPicker: false, //所属项目弹框
      showTimePicker: false, //时间控件
      currentDate: new Date(), //当前时间
      minDate: new Date(2000, 1, 1),
      refreshPage: false, // 网络请求失败时显示
      sendType: "", //判断是否在抄送列表
      clientType: getDeviceType(), //手机类型
      is_weixn: is_wei(), //是否为微信
    };
  },
  mounted() {
     if(is_wei()){
      document.title="印章申请";
    }
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.editType = this.mode == "add" ? true : false;
    this.commonId = this.$route.query.commonId; //申请Id
    window.editPage = this.editPage; //调用编辑
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    // window.setFile = this.setFiles; //app返回附件回调
    this.$nextTick(() => {
      this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
      if (this.mode == "edit" || this.mode == "verify"|| this.mode == "view") {
        this.initPage();
      } else {
        this.setShowLoad(false);
      }
    });
    document.title = "印章申请";
  },

  methods: {
    ...mapMutations(["setShowLoad"]),
    initPage() {
      this.setShowLoad(false);
      let _this = this;
      _this.$api.material.sealApply
        .detailsSeal(this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.sealApply = newApi.assign({}, _this.sealApply, res.data);
            _this.$set(_this.sealApply, "applyTypeName", "用章");
            var datas = res.data.sealNames.split(",");
            for (var i = 0; i < datas.length; i++) {
              _this.result.push(datas[i]);
            }

            if (
              (_this.sealApply.verifyStatus == "hold" ||
                _this.sealApply.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          _this.$toast("网络失败，请稍后重试");
        });
    },
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },
    editPage() {
      //需要编辑
      this.editType = true;
    },
    //监测附件方法
    changebaseAnnexes(data) {
      this.sealApply.baseAnnexes = data;
    },
    getSealModeList() {
      //获取印章列表
      let _this = this;
      _this.$api.material.sealApply.validSealList().then((res) => {
        if (res.code == "1") {
          _this.sealList = [];
          let obj = {};
          for (var i = 0; i < res.data.length; i++) {
            obj = {
              id: res.data[i].id,
              sealName: res.data[i].sealName,
            };
            _this.sealList.push(obj);
          }
        } else {
          _this.sealList = [];
        }
      });
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
      this.sealdata.push(this.sealList[index]);
      this.unique(this.sealdata);
    },
    checkSealPicker() {
      if (this.editType) {
        this.showSealPicker = true;

        this.getSealModeList();
      }
    },

    changeSealdata() {
      this.sealdata =
        JSON.parse(sessionStorage.getItem("sessionSealArr")) || [];
    },
    closeSealPicker() {
      let _this = this;
      let NewArr = [];

      let sessionSealArr =
        JSON.parse(sessionStorage.getItem("sessionSealArr")) || [];
      if (sessionSealArr != []) {
        for (let i = 0; i < sessionSealArr.length; i++) {
          NewArr.push(sessionSealArr[i].sealName);
        }
        _this.result = NewArr;
      } else {
        _this.result = [];
      }
      this.showSealPicker = false;
    },
    saveSeal() {
      let _this = this;
      let arr = [];
      let arr1 = [];
      let sessionSealArr = JSON.stringify(newApi.cloneDeep(_this.sealdata));
      sessionStorage.clear("sessionSealArr");
      sessionStorage.setItem("sessionSealArr", sessionSealArr);
      _this.sealdata.forEach((item) => {
        arr1.push(item.id);
        arr.push(item.sealName);
      });
      _this.sealApply.sealIds = arr1;
      _this.sealApply.sealNames = arr.join("，");
      this.showSealPicker = false;
    },
    unique(dataArray) {
      //数组去重
      let _this = this;
      let removeIndex = [];
      dataArray.forEach((item1, index1) => {
        const exist = dataArray.some(
          (item2, index2) => item1.id === item2.id && index1 !== index2
        );
        if (exist) {
          removeIndex.unshift(index1);
        }
      });
      newApi.each(removeIndex, (index) => {
        delete dataArray[index];
      });
      _this.sealdata = _this.sealdata.filter(function () {
        return true;
      });
    },
    //项目组件
    checkItemPicker() {
      if (this.editType) {
        this.showItemPicker = true;
      }
    },
    setProject(data) {
      //获取所属项目
      if (data != "") {
        this.sealApply.projectId = data.id;
        this.sealApply.projectName = data.name;
      }
      this.showItemPicker = false;
    },
    //时间控件
    TimePicker() {
      if (this.editType) {
        this.showTimePicker = true;
      }
    },
    onTimeConfirm(data) {
      this.showTimePicker = false;
      this.sealApply.sealTime = dateTimeFormat(data);
    },
      //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    //提交申请
    checkInput() {
      if (
        this.sealApply.projectId == "" ||
        this.sealApply.projectName == "" ||
        this.sealApply.fileAmount == "" ||
        this.sealApply.fileName == "" ||
        this.sealApply.reason == "" ||
        this.sealApply.sealTime == "" ||
        this.sealApply.sealIds.length == 0
      ) {
        this.$toast("带星号为必填，不能为空");
      } else {
        this.saveSealApplyMsg();
      }
    },
    //保存提交的信息
    saveSealApplyMsg() {
      var _this = this;
      _this.btnLoading = true;
      _this.$api.material.sealApply
        .addEditApply(this.mode, this.sealApply)
        .then((res) => {
          if (res.code == "1") {
            let text = this.mode == "add" ? "添加成功" : "编辑成功";
            closePage(text);
          } else {
            this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          console.log(err);
          _this.btnLoading = false;
          _this.$toast("网络失败，请稍后重试");
        });
    },
    delApply() {
      var _this = this;
      this.$dialog
        .alert({
          title: "删除",
          message: "你确定删除吗?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.material.sealApply
            .deleteApply(this.commonId)
            .then((res) => {
              if (res.code == "1") {
                let text = "删除操作成功";
                closePage(text);
              } else {
                this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch(() => {
              this.$toast("网络失败，请稍后重试");
              _this.btnLoading = false;
            });
        });
    },
    BackApply() {
      var _this = this;
      this.$dialog
        .alert({
          title: "撤回",
          message: "你确定撤回吗?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.material.sealApply
            .backApply(this.commonId)
            .then((res) => {
              if (res.code == 1) {
                let text = "撤回操作成功";
                closePage(text);
              } else {
                this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch(() => {
              this.$toast("网络失败，请稍后重试");
              _this.btnLoading = false;
            });
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.sealApplyPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  //项目
  .itemBox {
    width: 100%;
    height: 100%;
    padding-top: 5px;
  }
  #searchHeight {
    text-align: left;
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  > h4 {
    position: relative;
    border-bottom: 1px solid #e0e0e0;
    line-height: 45px;
    padding: 0 20px;
    font-weight: 700;
    color: #2581d6;
    font-size: 15px;
    z-index: 10;
    background-color: #fff;
  }
  > h4:before {
    content: "";
    position: absolute;
    width: 5px;
    height: 25px;
    background: #2581d6;
    top: 10px;
    left: 10px;
    bottom: 5px;
  }
  .itemPerson {
    textarea {
      text-align: right;
    }
  }

  .baseNone.beizhu {
    min-height: 45px;
  }

  .roleBox {
    width: 100%;
    height: 50%;
    padding-top: 5px;
    // overflow-y: initial;
    .roleHeader {
      position: relative;
      font-size: 14px;
      text-align: center;
      color: #333;
      border-bottom: 1px solid #f6f6f6;
      height: 15%;
      padding: 10px 0;
      a:first-child {
        color: rgb(235, 199, 155);
      }
      a {
        height: 100%;
        padding: 0 16px;
        color: #07c160;
        font-size: 14px;
      }
    }
    .roleMain {
      height: 85%;
      overflow-y: scroll;
    }
  }

  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }
  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
  //审批操作样式
}
</style>
